module.exports = __webpack_public_path__ + "static/media/upload.588f5dd0.svg";